
























import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product, ProductsApi, SimproApi, SimproJob } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

import Toast from './toast.vue';
import InlineEdit from '@/components/InlineEdit.vue';
import FormInputRow from '@/components/form pickers/FormInputRow.vue';
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';

@Component({
	components: {
		FormInputRow,
		InlineEdit,
	},
	validations: {
		notes: {
			required,
			minLength: minLength(1),
		},
	},
	mixins: [validationMixin],
})
export default class SimproJobModal extends Vue {
	@Prop({ required: false, type: Object })
	public product!: Product | null;

	@Prop({ required: false, type: Object })
	public job!: (SimproJob & { simproJobId: number }) | null;

	public submitting: boolean = false;
	public notes = '';

	private simproApi: SimproApi = new SimproApi();
	private productApi: ProductsApi = new ProductsApi();
	private toast: Toast = new Toast();

	public dismiss(): void {
		this.$bvModal.hide('simproJobSetStatusModal');
	}

	public async validate(e: Event) {
		e.preventDefault();
		if (!this.job?.id || !this.product?.id || !this.product?.orgId) return;

		const form = this.$v['notes'];
		form.$touch();
		if (form.$invalid) {
			return;
		}

		if (!form.$invalid) {
			this.submitting = true;
			try {
				await this.simproApi.setStatusToNewService(this.job.id, {
					data: {
						notes: this.notes,
					},
				});
				this.toast.makeToast('Job status updated successfully', 'Success', 'success');
				this.dismiss();
				this.$emit('dismiss');
			} catch (e) {
				const errorResponse = ApiUtils.handleApiError(e, 'Failed to change job status');
				this.toast.makeToast(
					errorResponse.errorMessage,
					'Job status change error',
					'danger',
					false,
				);
			}
			this.submitting = false;
		}
	}
}
